import React from "react";
import Link from "next/link";
import HamburgerMenu from "./HamburgerMenu";
import DesktopMenu from "./DesktopMenu";

export interface Route {
  name: string;
  link: string;
  /** Extra path prefixes that should light this heading up — for children that
   *  don't live under `link` (see app/lib/navActive.ts). */
  matchPaths?: string[];
  secondaryLinks?: { name: string; link: string }[];
}

export const routes: Route[] = [
  {
    name: "Work Together",
    link: "/workwithme",
    secondaryLinks: [
      { name: "Farleigh Method", link: "/workwithme/farleighMethod" },
      { name: "One-to-One Consultation", link: "/workwithme/consultation" },
      { name: "Follow Up", link: "/workwithme/flexibleConsult" },
      { name: "The Bodhi Club", link: "/workwithme/align" },
    ],
  },
  {
    name: "Treatments",
    link: "/treatments",
    matchPaths: ["/dayclinic"],
    secondaryLinks: [
      { name: "Day Clinic", link: "/dayclinic" },
      { name: "Body Ballancer", link: "/treatments/body-ballancer" },
      { name: "All Treatments", link: "/treatments" },
      { name: "Retreats", link: "/retreats" },
    ],
  },
  {
    name: "Shop",
    link: "/shop",
    secondaryLinks: [
      { name: "Shop All", link: "/shop" },
      { name: "6 Day Guided Cleanse", link: "/shop/feature" },
    ],
  },
  {
    name: "Learn",
    link: "/blog",
    secondaryLinks: [
      { name: "Blog", link: "/blog" },
      { name: "Wellness", link: "/wellness" },
      { name: "Nutrition", link: "/nutrition" },
      { name: "Instagram", link: "/blog/instagram" },
    ],
  },
  {
    name: "About",
    link: "/about",
    secondaryLinks: [
      { name: "Our Story", link: "/about" },
      { name: "Founder", link: "/about/founder" },
      { name: "Southport Clinic", link: "/about/wellbeing-southport" },
      { name: "Manchester Clinic", link: "/about/wellbeing-manchester" },
      { name: "Contact", link: "/contactus" },
    ],
  },
];

// Token reference — nav sits on --bg-page (burgundy dark):
//   nav text:       --text-on-dark       (cream)
//   nav text muted: --text-on-dark-muted (sand)
//   nav border:     --border-on-dark
//   CTA bg:         --btn-inverse-bg     (cream)
//   CTA text:       --btn-inverse-text   (burgundy ink)
//   CTA hover bg:   --btn-inverse-hover  (cream-dk)
//   focus ring:     --focus-ring         (sage)

const NavBar: React.FC = () => {
  return (
    <nav
      aria-label="Main navigation"
      className="border-b border-[var(--border-on-dark)]"
    >
      {/* ── Mobile layout: 3-column grid, no absolute positioning ── */}
      <div className="lg:hidden grid grid-cols-3 items-center px-4 py-3">
        {/* Col 1: hamburger left */}
        <div className="flex justify-start">
          <HamburgerMenu routes={routes} />
        </div>

        {/* Col 2: spacer keeps CTA pinned right */}
        <div />

        {/* Col 3: CTA right */}
        <div className="flex justify-end">
          <Link
            href="/workwithme/discoverycall"
            className="
              px-3.5 py-2 rounded-xl text-sm font-medium whitespace-nowrap
              bg-[var(--btn-inverse-bg)] text-[var(--btn-inverse-text)]
              hover:bg-[var(--btn-inverse-hover)] transition-colors
              focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--focus-ring)]
            "
          >
            Free discovery call
          </Link>
        </div>
      </div>

      {/* ── Desktop layout ── */}
      <div className="hidden lg:flex items-center px-4 py-3 container mx-auto">
        <DesktopMenu routes={routes} />
      </div>
    </nav>
  );
};

export default NavBar;
